export interface Command {
    hidden?: boolean;
    disabled: boolean;
}

/**
 * Combines given commands applying OR logic for each field.
 * At least one command must be hidden to hide the result.
 * At least one command must be disabled to disable the result.
 * @param commands commands to combine
 */
export function combineCommandsOr(...commands: Command[]): Command {
    return {
        disabled: commands.some((c) => Boolean(c.disabled)),
        hidden: commands.some((c) => Boolean(c.hidden)),
    };
}

/**
 * Combines given commands applying AND logic for each field.
 * All commands must be hidden to hide the result.
 * All commands must be disabled to disable the result.
 * @param commands commands to combine
 */
export function combineCommandsAnd(...commands: Command[]): Command {
    return {
        disabled: commands.every((c) => Boolean(c.disabled)),
        hidden: commands.every((c) => Boolean(c.hidden)),
    };
}
